import * as yup from 'yup';
import { SuggestionSchema, ScaleRatingSuggestionSchema } from '../../../common';

export const PainProtocolSuggestionSchema = yup.object({
  painLocalizationSpread: SuggestionSchema.nullable(),
  painRelatedAccompanyingSymptoms: SuggestionSchema.nullable(),
  painDurationTime: SuggestionSchema.nullable(),
  painCausingFactors: SuggestionSchema.nullable(),
  painExpression: SuggestionSchema.nullable(),
  painRelief: SuggestionSchema.nullable(),
  abnormalitiesRest: ScaleRatingSuggestionSchema.nullable(),
  abnormalitiesStrain: ScaleRatingSuggestionSchema.nullable(),
  measures: SuggestionSchema.nullable(),
});

export type IPainProtocolSuggestion = yup.InferType<typeof PainProtocolSuggestionSchema>;
